export default __webpack_public_path__ + "static/media/gs8-sme.ee13f69e.jpg";